import translations from './translations'

translations.add('en', {
    closePaymentMethods: 'close payment methods',
    otherPaymentMethods: 'other payment methods'
})
